import api from './index'
import { axios, changeWebPublic } from '@/utils/request'

export function getUserList(parameter) {
  return axios({
    url: '/user/list',
    method: 'post',
    data: parameter
  })
}

export function getColUserList(parameter) {
  return axios({
    url: '/user/colList',
    method: 'post',
    data: parameter
  })
}

export function getAdminColUserList(parameter) {
  return axios({
    url: '/user/colAdminList',
    method: 'post',
    data: parameter
  })
}

export function resetGAuth(parameter) {
  return axios({
    url: '/user/reset_google_auth',
    method: 'post',
    data: parameter
  })
}


export function getRoleList(parameter) {
  return axios({
    url: '/role/list',
    method: 'post',
    data: parameter
  })
}

export function addUser(parameter = {}) {
  return axios({
    url: '/user/add',
    method: 'post',
    data: parameter
  })
}

export function addColUser(parameter = {}) {
  return axios({
    url: '/user/addCol',
    method: 'post',
    data: parameter
  })
}

export function addAdminColUser(parameter = {}) {
  return axios({
    url: '/user/addAdminCol',
    method: 'post',
    data: parameter
  })
}

export function editColUser(parameter = {}) {
  return axios({
    url: '/user/editCol',
    method: 'post',
    data: parameter
  })
}

export function editAdminColUser(parameter = {}) {
  return axios({
    url: '/user/editAdminCol',
    method: 'post',
    data: parameter
  })
}


export function editUser(parameter = {}) {
  return axios({
    url: '/user/edit',
    method: 'post',
    data: parameter
  })
}
export function deleteUser(parameter) {
  return axios({
    url: '/user/delete',
    method: 'post',
    data: parameter
  })
}

export function deleteCallUser(parameter) {
  return axios({
    url: '/user/deleteCallUser',
    method: 'post',
    data: parameter
  })
}

export function clearGaid(parameter) {
  return axios({
    url: '/user/clearGaid',
    method: 'post',
    data: parameter
  })
}

export function getAllRoleList(parameter = {}) {
  return axios({
    url: '/role/selectList',
    method: 'post',
    data: parameter
  })
}
export function getAppAllRoleList(parameter = {}) {
  return axios({
    url: '/role/selectAppList',
    method: 'post',
    data: parameter
  })
}
export function addRole(parameter = {}) {
  return axios({
    url: '/role/add',
    method: 'post',
    data: parameter
  })
}

export function editRole(parameter = {}) {
  return axios({
    url: '/role/edit',
    method: 'post',
    data: parameter
  })
}
export function getPermissionsByRole(parameter = {}) {
  return axios({
    url: '/role/role_permissions',
    method: 'post',
    data: parameter
  })
}

export function getRolePermission(parameter = {}) {
  return axios({
    url: '/role/permissions',
    method: 'post',
    data: parameter
  })
}
export function setRolePermission(parameter = {}) {
  return axios({
    url: '/role/grant',
    method: 'post',
    data: parameter
  })
}

export function getMenuListTree(parameter = {}) {
  return axios({
    url: '/menu/listTree',
    method: 'post',
    data: parameter
  })
}
export function addMenu(parameter = {}) {
  return axios({
    url: '/menu/add',
    method: 'post',
    data: parameter
  })
}
export function editMenu(parameter = {}) {
  return axios({
    url: '/menu/edit',
    method: 'post',
    data: parameter
  })
}
export function deleteMenu(parameter = {}) {
  return axios({
    url: '/menu/delete',
    method: 'post',
    data: parameter
  })
}
// Get dictionary list
export function getDict(parameter = {}) {
  return axios({
    url: '/dict/list',
    method: 'post',
    data: parameter
  })
}
// Add dictionary
export function addDict(parameter = {}) {
  return axios({
    url: '/dict/add',
    method: 'post',
    data: parameter
  })
}

// Edit dictionary
export function editDict(parameter = {}) {
  return axios({
    url: '/dict/edit',
    method: 'post',
    data: parameter
  })
}

// Delete dictionary
export function deleteDict(parameter = {}) {
  return axios({
    url: '/dict/delete',
    method: 'post',
    data: parameter
  })
}

// Get dictionary detail list
export function getDictItem(parameter = {}) {
  return axios({
    url: '/dictItem/list',
    method: 'post',
    data: parameter
  })
}

// Add dictionary detail
export function addDictItem(parameter = {}) {
  return axios({
    url: '/dictItem/add',
    method: 'post',
    data: parameter
  })
}

// Edit dictionary detail
export function editDictItem(parameter = {}) {
  return axios({
    url: '/dictItem/edit',
    method: 'post',
    data: parameter
  })
}

// Edit dictionary detail
export function deleteDictItem(parameter = {}) {
  return axios({
    url: '/dictItem/delete',
    method: 'post',
    data: parameter
  })
}

// Clear cache
export function clearDictCache(parameter = {}) {
  return axios({
    url: '/dict/refresh',
    method: 'post',
    data: parameter
  })
}

// App management
export function getAppList(parameter = {}) {
  return axios({
    url: '/app/list',
    method: 'post',
    data: parameter
  })
}
export function addApp(parameter = {}) {
  return axios({
    url: '/app/add',
    method: 'post',
    data: parameter
  })
}
export function editApp(parameter = {}) {
  return axios({
    url: '/app/edit',
    method: 'post',
    data: parameter
  })
}
export function deleteApp(parameter = {}) {
  return axios({
    url: '/app/delete',
    method: 'post',
    data: parameter
  })
}

// App management-Employee management
export function getEmployee(parameter = {}) {
  return axios({
    url: '/appUser/list',
    method: 'post',
    data: parameter
  })
}
export function addEmployee(parameter = {}) {
  return axios({
    url: '/appUser/add',
    method: 'post',
    data: parameter
  })
}
export function editEmployee(parameter = {}) {
  return axios({
    url: '/appUser/edit',
    method: 'post',
    data: parameter
  })
}
export function deleteEmployee(parameter = {}) {
  return axios({
    url: '/appUser/delete',
    method: 'post',
    data: parameter
  })
}

export function getAppSettingList(parameter = {}) {
  return axios({
    url: '/app/listAppSetting',
    method: 'post',
    data: parameter
  })
}

export function editAppSetting(parameter = {}) {
  return axios({
    url: '/app/editAppSetting',
    method: 'post',
    data: parameter
  })
}

export function addAppSetting(parameter = {}) {
  return axios({
    url: '/app/addAppSetting',
    method: 'post',
    data: parameter
  })
}

export function deleteAppSetting(parameter = {}) {
  return axios({
    url: '/app/deleteAppSetting',
    method: 'post',
    data: parameter
  })
}

export function getAppStrategyidList(parameter = {}) {
  return axios({
    url: '/app/listAppStrategyid',
    method: 'post',
    data: parameter
  })
}
export function addAppStrategyid(parameter = {}) {
  return axios({
    url: '/app/addAppStrategyid',
    method: 'post',
    data: parameter
  })
}

export function getDurationsByAppParentId(parentId) {
  return axios({
    url: '/product/getDurationsByAppParentId?parentId=' + parentId,
    method: 'get',
  })
}

export function addAppSub(parameter = {}) {
  return axios({
    url: '/app/addAppSub',
    method: 'post',
    data: parameter
  })
}

export function getAllSubAppById(id) {
  return axios({
    url: '/app/getAllSubAppById?id=' + id,
    method: 'get',
  })
}

export function userBlackList(parameter = {}) {
  return axios({
    url: '/user/userBlackList',
    method: 'post',
    data: parameter
  })
}

export function stopCollection(parameter = {}) {
  return axios({
    url: '/user/stopCollection',
    method: 'post',
    data: parameter
  })
}

export function cancelUser(parameter = {}) {
  return axios({
    url: '/user/cancelUser',
    method: 'post',
    data: parameter
  })
}

// App management
export function getAppSettingCpList(parameter = {}) {
  return axios({
    url: '/app/setting/queryList',
    method: 'post',
    data: parameter
  })
}


export function editCpAppSetting(parameter = {}) {
  return axios({
    url: '/app/setting/editSetting',
    method: 'post',
    data: parameter
  })
}

export function addCpSetting(parameter = {}) {
  return axios({
    url: '/app/setting/addSetting',
    method: 'post',
    data: parameter
  })
}

export function findRedisByKey(key) {
  return axios({
    url: '/test/findRedisByKey?key=' + key,
    method: 'post',
  })
}

export function delRedis(key) {
  return axios({
    url: '/test/delRedis?key=' + key,
    method: 'post',
  })
}

export function getAllSysUser() {
  return axios({
    url: '/user/findAllUser',
    method: 'get',
  })
}


export function getcountUserIdTaskNum(parameter = {}) {
  changeWebPublic('')
  return axios({
    url: '/api/web/webpublic/pcColl/countUserIdTaskNum',
    method: 'post',
    data: parameter
  }).finally(() => changeWebPublic('/webpublic'))
}


// Cloud customer management
export function getYunkePage(parameter = {}) {
  // Cloud customer module not available in some environments webpublic Under prefix, temporarily switch prefix to avoid 404
  changeWebPublic('')
  return axios({
    url: '/yunke/getPage',
    method: 'post',
    data: parameter
  }).finally(() => changeWebPublic('/webpublic'))
}

export function saveOrUpdateYunke(parameter = {}) {
  changeWebPublic('')
  return axios({
    url: '/yunke/saveOrUpdate',
    method: 'post',
    data: parameter
  }).finally(() => changeWebPublic('/webpublic'))
}

export function deleteYunke(id, userInfo = {}) {
  changeWebPublic('')
  return axios({
    url: '/yunke/delete?id=' + id,
    method: 'post',
    data: { userInfo }
  }).finally(() => changeWebPublic('/webpublic'))
}

export function getOutboundPage(parameter = {}) {
  changeWebPublic('')
  return axios({
    url: '/yunkeOutCall/getPage',
    method: 'post',
    data: parameter
  }).finally(() => changeWebPublic('/webpublic'))
}

export function getOutboundRecord(parameter = {}) {
  changeWebPublic('')
  return axios({
    url: '/yunkeOutCall/getPageByOutCall',
    method: 'post',
    data: parameter
  }).finally(() => changeWebPublic('/webpublic'))
}

export function getCallRecords(parameter = {}) {
  changeWebPublic('')
  return axios({
    url: '/yunkeCallRecords/getPage',
    method: 'post',
    data: parameter
  }).finally(() => changeWebPublic('/webpublic'))
}

export function getUserLog(parameter = {}) {
  changeWebPublic('')
  return axios({
    url: 'webpublic/customer/log/search',
    method: 'post',
    data: parameter
  })
}


